import React from "react";

const Footer = () => {
  
  return (
    <footer>
      <div className="pull-right">
        © {new Date().getFullYear()} Vivashri. All Rights Reserved.
      </div>
      <div className="clearfix"></div>
    </footer>
  );
};

export default Footer;
